import { Code, CredentialEnum, RuleParams, timeStr2Millis } from '@orgbrain/lib-data';
import { Session } from '../lib-admin';
import * as Auth from './org-auth-classes';
import { sharedConfig } from '@orgbrain/shared-config';

function require_credentials_evalIML({
  session,
  params,
  preemptiveReport,
}: Auth.RuleEvaluateArgs): Auth.RuleResult {
  if (params?.assertLoginCredentials) {
    for (const cred of params.assertLoginCredentials as CredentialEnum[]) {
      if (session.credentials[cred]) {
        return { pass: true, expires: sharedConfig.securityTiming.NOEXPIRETIME };
      }
    }

    return {
      pass: false,
      mfaCredentialsRequired: params.assertLoginCredentials,
      expires: -1,
    };
  }

  // else {
  //   console.error('No preemptiveReport' + new Error().stack);
  // }

  return { pass: true, expires: sharedConfig.securityTiming.NOEXPIRETIME };
}

// Note that preemptiveReport is only used in  the frontend
export function require_credentials_if_inactive_for_period_evalIMPL({
  session,
  params,
  preemptiveReport,
}: Auth.RuleEvaluateArgs): Auth.RuleResult {
  let expires = -10000000000;

  const credExpires = {} as any;

  for (const credStr of Object.keys(session.credentials)) {
    if (params.credentials2FA.includes(credStr as CredentialEnum)) {
      const cred = credStr as CredentialEnum;
      const expiresX = require_credential_eval_expiresIMPL({
        session,
        cred: cred as CredentialEnum,
        params,
        nowOverride: preemptiveReport?.nowOverride,
      });
      credExpires[cred] = expiresX;

      if (expiresX > expires) {
        expires = expiresX;
      }
    }
  }

  if (expires >= 0) {
    return { pass: true, expires, credExpires };
  }

  return {
    pass: false,
    mfaCredentialsRequired: params.credentials2FA,
    expires,
    credExpires,
  };
}

// Return negative if is not valid or expired
// OTHERWISE return the number of milliseconds until it expires
// 0 means it will not expire
function require_credential_eval_expiresIMPL({
  session,
  cred,
  params,
  nowOverride,
}: {
  session: Session;
  cred: CredentialEnum;
  params: RuleParams;
  nowOverride: number;
}): number {
  if (!session.credentials[cred]) {
    return -1;
  }

  if (!params.credentials2FA.includes(cred)) {
    return -2;
  }

  const limit = timeStr2Millis(params.inactivityPeriod);

  if (session.inactivityPeriod[cred] === undefined) {
    return sharedConfig.securityTiming.UNDEFINEDTIME;
  }

  if (limit < session.inactivityPeriod[cred]) {
    return limit - session.inactivityPeriod[cred];
  }

  const now = nowOverride || Date.now();

  const inactivity = now - new Date(session.lastActivity).getTime();

  if (inactivity > limit) {
    return -3;
  }

  return limit - inactivity;
}

// export function require_session_credentials_eval({
//   user,
//   params,
// }: Auth.RuleEvaluateArgs): Auth.RuleResult {
//   const session: Session = user.session;
//   if (!session) {
//     throw Auth.Deny({ message: 'No session for user ', authcode: Code.FATAL });
//   }

//   for (const key of Object.keys(session.credentials)) {
//     const cred = key as CredentialEnum;
//     if (params.credentials2FA.includes(cred as CredentialEnum)) {
//       return { pass: true, credentials2FA: [cred] };
//     }
//   }
//   return { pass: false, credentials2FA: params.credentials2FA };
// }

export function no_requirments_eval({
  session,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  params,
}: Auth.RuleEvaluateArgs): Auth.RuleResult {
  if (!session) {
    throw Auth.Deny({ message: 'No session for user ', authcode: Code.FATAL });
  }

  return { pass: true, expires: sharedConfig.securityTiming.NOEXPIRETIME };
}

export const require_session_credential_period: Auth.AtomicRuleImplemention = {
  evaluateFunc: require_credentials_if_inactive_for_period_evalIMPL,
};

export const no_requirements: Auth.AtomicRuleImplemention = {
  evaluateFunc: no_requirments_eval,
};

export const require_logon_credentials: Auth.AtomicRuleImplemention = {
  evaluateFunc: require_credentials_evalIML,
};
